import React, {Component} from 'react';
import { BrowserRouter, Switch, Link, Route } from 'react-router-dom';
import VisionContent from '../components/VisionContent'; 
import axios from 'axios'; 

import Header from '../common/Header'; 
import Footer from '../common/Footer';
import PageHeader from '../components/PageHeader'; 
import { Helmet } from "react-helmet";
import { base_url} from '../common/Constants';
 
class Vision extends React.Component{

    constructor(){
        super(); 
    }
 
    render()
    {
        const content = JSON.parse(localStorage.getItem("content"));
        const metas = JSON.parse(localStorage.getItem("metas"));
        return (
            <div className="page-wrapper">
                <Header/> 
                <Helmet>
                    <title>{metas[1].title}</title>  
                    <meta name="description" content={metas[5].meta_description} />
                    <meta name="keywords" content={metas[5].meta_title} />
                    <meta property="og:image" content={content[5].image}  />
                    <link rel="canonical" href={base_url+'vision-mission'} />
                </Helmet>
                <PageHeader title="VISION, MISSION AND QUALITY"  banner="About"/>
                <VisionContent content={JSON.parse(localStorage.getItem("content"))}/>  
                <Footer/>
            </div>
       
        )
    }

}
export default Vision;